export default "__VITE_ASSET__8ac0080f__$_?nuxt_component=async__"